// extracted by mini-css-extract-plugin
module.exports = {"youtubeVideo":"youtube-video-module--youtubeVideo--1zsGx"};